if (!customElements.get("return-and-exchanges")) {
  class ReturnAndExchanges extends HTMLElement {
    constructor() {
      super();

      this.settings = {
        type: "loop",
        perMove: 1,
        lazyLoad: "sequential",
        arrows: true,
        gap: 12,
        pagination: true,
      };

      this.returnUsElement = document.getElementById("splide__return-us-exchanges");
      this.returnCanadaElement = document.getElementById("splide__return-ca-exchanges");
      this.returnAuElement = document.getElementById("splide__return-au-exchanges");
      this.returnOtherElement = document.getElementById("splide__return-other-exchanges");
      this.returnNzElement = document.getElementById("splide__return-nz-exchanges");
    }

    connectedCallback() {
      const shop = Shopify.shop;
      if (shop === "beginningboutique-us.myshopify.com") {
        if (this.returnUsElement) new Splide(this.returnUsElement, this.settings).mount();
        if (this.returnCanadaElement) new Splide(this.returnCanadaElement, this.settings).mount();
      } else if (shop === "beginningboutique-nz.myshopify.com") {
        if (this.returnNzElement) new Splide(this.returnNzElement, this.settings).mount();
      } else {
        if (this.returnAuElement) new Splide(this.returnAuElement, this.settings).mount();
        if (this.returnOtherElement) new Splide(this.returnOtherElement, this.settings).mount();
      }
    }
  }

  if (location.pathname.includes("returns-and-exchanges")) {
    customElements.define("return-and-exchanges", ReturnAndExchanges);

    document.addEventListener("DOMContentLoaded", () => {
      const ReturnAndExchangesElement = document.createElement("return-and-exchanges");
      document.body.appendChild(ReturnAndExchangesElement);
    });
  }
}
